/**
 * @prettier
 */
import { requireBooleanString } from 'src/utils/require/requireBooleanString';

export function envUI_LOG_EVENT_DISABLED(): boolean {
    return JSON.parse(requireBooleanString(process.env.UI_LOG_EVENT_DISABLED || 'false'));
}
